// extracted by mini-css-extract-plugin
export default {"root":"LimitedAccessBanner_root__btAGx","text":"LimitedAccessBanner_text__AlR1R","button":"LimitedAccessBanner_button__7ch-r"};